export default __webpack_public_path__ + "static/media/3132 spice rack E top.53dcc0c4.png";